import { apiService } from "../apiServices";
import config from "../../../config/domain";
import servicesList from "../serviceList";
import { isGetAccessor } from "typescript";

export const APendingUploadList = (
  callback: CallableFunction,
  applicationid: string
) => {
  apiService(
    {
      url: "Document/GetDetails",
      body: {
        ApplicationId: applicationid,
        InputDataType: 1,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getDocumentDetails,
      encrypted: true,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-pending-document-list",
  //     body: {
  //       applicationid: applicationid,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const APendingApprovalList = (
  callback: CallableFunction,
  applicationid: string
) => {
  apiService(
    {
      url: "Document/GetDetails",
      body: {
        ApplicationId: applicationid,
        InputDataType: 3,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getDocumentDetails,
      encrypted: true,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-doc-status",
  //     body: {
  //       applicationid: applicationid,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AValidateServicableCityPincode = (
  callback: CallableFunction,
  pincode: string
) => {
  apiService(
    {
      url: "eco/validate-servicable-city-pincode",
      body: {
        Pincode: pincode,
      },
      method: "POST",
      encrypted: true,
    },
    callback
  );
};

export const AAgentDatesList = (callback: CallableFunction) => {
  apiService(
    {
      url: "eco/date-for-agent-visit",
      method: "POST",
      encrypted: true,
    },
    callback
  );
};

export const AAgentTimesList = (callback: CallableFunction) => {
  apiService(
    {
      url: "eco/time-for-agent-visit",
      method: "POST",
      encrypted: true,
    },
    callback
  );
};

export const ASaveAgentVisitDetails = (
  callback: CallableFunction,
  agentVisitObj: any
) => {
  apiService(
    {
      url: "eco/save-agent-visit-details",
      body: agentVisitObj,
      method: "POST",
      encrypted: true,
    },
    callback
  );
};

export const AGetAgentVisitDetails = (
  callback: CallableFunction,
  applicationid: string
) => {
  apiService(
    {
      url: "eco/get-agent-visit-details",
      body: {
        applicationid: applicationid,
      },
      method: "POST",
      encrypted: true,
    },
    callback
  );
};

export const ACreateHelpTicket = (callback: CallableFunction, reqObj: any) => {
  apiService(
    {
      url: "eco/create-help-ticket",
      body: reqObj,
      method: "POST",
      encrypted: true,
    },
    callback
  );
};
export const AgetAMLDetails = (
  callback: CallableFunction,
  applicationid: string,
) => {
  apiService(
    {
      url: "Esign/Traq",
      body: {
        applicationId: applicationid,
        
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getAMLDetails,
      encrypted: true,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-esign-link",
  //     body: {
  //       applicationid: applicationid,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};


export const AGetRMEsignUrlDetails = (
  callback: CallableFunction,
  applicationid: string,
  esigndocumenttype: number,
  accountCategory: number,
  userId?: number
) => {
  apiService(
    {
      url: "Esign/GetRMAssistLink",
      body: {
        applicationId: applicationid,
        esignDocumentType: esigndocumenttype,
        accountCategory: accountCategory,
        UserId: userId,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getRMAssitedEsignLink,
      encrypted: true,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-esign-link",
  //     body: {
  //       applicationid: applicationid,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const AGetEsignUrlDetails = (
  callback: CallableFunction,
  applicationid: string,
  esigndocumenttype: number,
  accountCategory: number,
  panNo?: string
) => {
  apiService(
    {
      url: "Esign/GetLink",
      body: {
        ApplicationId: applicationid,
        esigndocumenttype: esigndocumenttype,
        accountCategory: accountCategory,
        PanNo: panNo
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getEsignLink,
      encrypted: true,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-esign-link",
  //     body: {
  //       applicationid: applicationid,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const AGetRMEsignVerificationUrlDetails = (
  callback: CallableFunction,
  applicationid: string,
  esigndocumenttype: number,
  accountCategory: number,
  userId: number
) => {
  apiService(
    {
      url: "Esign/RMVerificationLink",
      body: {
        applicationId: applicationid,
        esignDocumentType: esigndocumenttype,
        accountCategory: accountCategory,
        esignVendorType: 0,
        userId: userId
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getEsignLink,
      encrypted: true,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-esign-link",
  //     body: {
  //       applicationid: applicationid,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AGetClientAccountCode = (
  callback: CallableFunction,
  applicationid: string
) => {
  let tempObj = {
    ApplicationId: applicationid,
  }
  apiService(
    {
      url: "AccountDetail/GetV1",
      // body: {
      //   ApplicationId: applicationid,
      // },
      body: tempObj,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getAccountcodeData,
      encryption: true,
      encryptedString: true,
      encrypted: true,
    },
    callback
  );
  //   apiService(
  //     {
  //       url: "eco/get-client-account-code",
  //       body: {
  //         applicationId: applicationid,
  //       },
  //       method: "POST",
  //     },
  //     callback
  //   );
};

export const AGetClientAccountCodeV1 = (
  callback: CallableFunction,
  encryptedString: string
) => {
  apiService(
    {
      url: "AccountDetail/GetV1",
      body: {
        encryptedString: encryptedString,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getAccountcodeData,
      encrypted: true,
    },
    callback
  );
};

export const AValidatePoaServicableCityPincode = (
  callback: CallableFunction,
  pincode: string
) => {
  apiService(
    {
      url: `eco/checkPincodeJavaMW?pincode=${pincode}`,
      method: "GET",
      encrypted: true,
    },
    callback
  );
};

export const ASavePoaDetails = (callback: CallableFunction, reqObj: any) => {
  apiService(
    {
      url: "eco/SavePoaScheduleJavaMW",
      body: reqObj,
      method: "POST",
      encrypted: true,
    },
    callback
  );
};

export const ADownloadForm = (
  callback: CallableFunction,
  applicationid: string,
  isFullPdf: boolean,
  accountCategory?: any,
  isKycDownload?: boolean,
) => {
  let body: any = {
    ApplicationId: applicationid,
    accountCategory: accountCategory,
    isKYCDownload: isKycDownload
  };
  if (isFullPdf) {
    body.EsignFlag = 1;
  }
  apiService(
    {
      url: "Document/KycPdf",
      body: body,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.generateKYCPdf,
      encrypted: true,
    },
    callback
  );
  // let url = isFullPdf ? "saveKycFullFormJavaMW" : "DownLoadAndCourierJavaMW";
  // apiService(
  //   {
  //     url: `eco/${url}?applicationId=${applicationid}`,
  //     method: "GET",
  //   },
  //   callback
  // );
};

export const AUpdatePanAddharLinkStatus = (
  callback: CallableFunction,
  applicationid: string,
  ispanaadhaarlinked: boolean
) => {
  apiService(
    {
      url: "DIYAPI/UpdatePanAddharLinkStatus",
      body: {
        ApplicationId: applicationid,
        ispanaadhaarlinked: ispanaadhaarlinked,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.updatePanAddharLinkStatus,
      encrypted: true,
    },
    callback
  );
};
